import { gql } from '@apollo/client';

export const REVIEW_START_DELIVERY = gql`
  mutation ReviewStartDelivery($deliverAccountId: Long!, $id: Long!, $operatorName: String) {
    reviewStartDelivery(deliverAccountId: $deliverAccountId, id: $id, operatorName: $operatorName)
  }
`;

export interface ReviewStartDeliveryResponse {
  reviewStartDelivery: boolean;
}

export interface ReviewStartDeliveryInput {
  deliverAccountId: number;
  id: number;
  operatorName?: string | null;
} 